import { Slot } from 'primitives/slot'
import * as React from 'react'
import { tw } from 'utils/classnames'

/** @deprecated Use {@link SectionTabs} or {@link NavigationTabs}. */
export type TabVariant = 'Line' | 'LineSmall' | 'Default' | 'Icon' | 'Small' | 'Mini'
type Colors = 'dark' | 'light'

/** @deprecated Use {@link SectionTabs} or {@link NavigationTabs}. */
interface TabProps extends Omit<React.ComponentProps<'button'>, 'ref'> {
  variant?: TabVariant
  color?: Colors
  asChild?: boolean
  ref?: React.Ref<HTMLButtonElement>
}

/** @deprecated Use {@link SectionTabs} or {@link NavigationTabs}. */
export interface TabsProps {
  value: string
  label: string
  icon?: React.ReactNode
}

/**
 * @deprecated Use {@link SectionTabs} to toggle views within a page section, or
 * {@link NavigationTabs} for top-level page navigation.
 */
export function Tab({
  color: _color = 'light',
  variant = 'Small',
  asChild,
  ref,
  ...props
}: TabProps) {
  const className = tw(
    'outline-none focus-visible:outline',
    props.disabled && 'cursor-not-allowed',
    tabsClasses.variants[variant],
    tabsClasses.active[variant],
    props.className,
  )

  const Comp = asChild ? Slot : 'button'
  const buttonProps = asChild ? {} : { type: 'button' as const }

  return <Comp {...buttonProps} {...props} className={className} ref={ref} />
}
const violetStyleColors =
  'text-gray-400 enabled:hover:bg-gray-700 enabled:hover:text-gray-300 bg-gray-800/80 transition-all'
const violetStyleActiveColors =
  'data-[state="active"]:bg-studio-violet-500 data-[state="active"]:text-service-white data-[state="active"]:bg-opacity-100'

const tabsClasses = {
  variants: {
    Line: `pt-[14px] pb-4 px-3 text-gray-400 typography-13`,
    LineSmall: `pt-[2px] pb-[10px] px-3 text-gray-400 typography-13`,
    Default: `py-[9.5px] px-4 typography-14 rounded-2 backdrop-blur-sm ${violetStyleColors}`,
    Icon: `p-1 rounded-2 backdrop-blur-sm ${violetStyleColors}`,
    Small: `py-1 px-3 typography-12 rounded-2 ${violetStyleColors}`,
    Mini: 'py-1 px-1.5 text-gray-400 typography-12 rounded-2 bg-gray-800/25 text-gray-50 enabled:hover:bg-gray-700 enabled:hover:text-gray-300',
  },
  active: {
    Line: 'data-[state="active"]:border-b-2 data-[state="active"]:border-violet-500 data-[state="active"]:pb-[14px] data-[state="active"]:text-gray-50',
    LineSmall:
      'data-[state="active"]:border-b-2 data-[state="active"]:border-violet-500 data-[state="active"]:pb-[8px] data-[state="active"]:text-gray-50',
    Default: violetStyleActiveColors,
    Icon: violetStyleActiveColors,
    Small: violetStyleActiveColors,
    Mini: 'data-[state="active"]:bg-gray-800 data-[state="active"]:text-gray-50',
  },
}

// oxlint-disable-next-line cf-web/no-barrel-file
export { NavigationTabs } from './navigation-tabs'
// oxlint-disable-next-line cf-web/no-barrel-file
export type {
  NavigationTabsRootProps,
  NavigationTabsSize,
  NavigationTabsTabProps,
} from './navigation-tabs'
// oxlint-disable-next-line cf-web/no-barrel-file
export { SectionTabs } from './section-tabs'
// oxlint-disable-next-line cf-web/no-barrel-file
export type {
  SectionTabsRootProps,
  SectionTabsSize,
  SectionTabsTabProps,
  SectionTabsVariant,
} from './section-tabs'
